/**
 * @generated SignedSource<<3d8040dceb09bffa2372c24c4b45b5cf>>
 * @relayHash 6fe4212cadd4d112648bbcc0d52393c4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 83192256e99e0201f3a351188ab756376f09ac993c756f22af34b11b8d730d04

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { main_getIssueTransitionByIdRootQuery } from './main_getIssueTransitionByIdRootQuery.graphql';

const node: PreloadableConcreteRequest<main_getIssueTransitionByIdRootQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "83192256e99e0201f3a351188ab756376f09ac993c756f22af34b11b8d730d04",
    "metadata": {},
    "name": "main_getIssueTransitionByIdRootQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
